<template>
  <AbsPopup id="EpubInfo" title="서지정보 만들기" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body">
        <UInput type="text" tag="li" placeholder="상단 제목이 표시됩니다" v-model="title" :readonly="true">
          <span><span class="require">*</span>서명</span>
        </UInput>
        <UInput type="text" tag="li" placeholder="작가이름" v-model="creator">
          <span><span class="require">*</span>저자</span>
        </UInput>
        <UInput type="text" tag="li" placeholder="번역" v-model="translator">
          <span>역자</span>
        </UInput>
        <UInput type="text" tag="li" placeholder="그린사람" v-model="illustrator">
          <span>삽화</span>
        </UInput>
        <UInput type="text" tag="li" placeholder="타이포" v-model="dsr">
          <span>타이포</span>
        </UInput>
        <UInput type="text" tag="li" placeholder="기타" v-model="other">
          <span>기타</span>
        </UInput>
        <UInput type="text" tag="li" placeholder="YYYYMMDD" v-model="date">
          <span><span class="require">*</span>발행일</span>
        </UInput>
        <UInput type="text" tag="li" placeholder="" v-model="paperDate">
          <span>종이책 발행일</span>
        </UInput>
        <UInput type="text" tag="li" placeholder="유펜비" v-model="publisher">
          <span><span class="require">*</span>발행처</span>
        </UInput>
        <UInput type="text" tag="li" placeholder="- 포함 입력해주세요" v-model="phone">
          <span><span class="require">*</span>전화번호</span>
        </UInput>
        <UInput type="text" tag="li" placeholder="" v-model="addr">
          <span><span class="require">*</span>주소</span>
        </UInput>
        <UInput type="text" tag="li" placeholder="" v-model="email">
          <span><span class="require">*</span>이메일</span>
        </UInput>
        <UInput type="text" tag="li" placeholder="- 포함 입력해주세요" v-model="isbn">
          <span><span class="require">*</span>ISBN</span>
        </UInput>
        <UInput type="text" tag="li" placeholder="- 포함 입력해주세요" v-model="setIsbn">
          <span>세트 ISBN</span>
        </UInput>
        <UInput type="text" tag="li" placeholder="- 포함 입력해주세요" v-model="paperIsbn">
          <span>종이책 ISBN</span>
        </UInput>
        <li>
          <span>
            저작권자 및 출판사의 서면 동의 없이는 어떠한 형태나 수단으로 이 전자책과 책의 내용을 이용할 수 없으며, 이 전자책은 저작권법에 의해 보호받는 저작물이므로 무단전재 또는 무단복제 할 경우 법적 책임을 질수 있습니다.
          </span>
        </li>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'

export default {
  props: {
    option: {
      type: Object
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    // if (this.option.param) {
    //   if (this.option.param.title) {
    //     this.title = this.option.param.title
    //   }
    // }
    if (this.option.param) {
      // this.title = this.option.param.title
      var s
      for (s in this.option.param.info) {
        this[s] = this.option.param.info[s]
      }
    }
    this.$emit('loading', false)
  },
  data () {
    return {
      // 서명 (제목)
      // title: null,
      // 저자
      creator: null,
      isbn: null,
      // 발행처
      publisher: null,
      // 발행일
      date: null,
      // 번역
      translator: null,
      // 삽화
      illustrator: null,
      dsr: null,
      // 기타
      other: null,
      // 전화번호
      phone: null,
      // 주소
      addr: null,
      email: null,
      // 종이책 발행일
      paperDate: null,
      paperIsbn: null,
      setIsbn: null
    }
  },
  name: 'EpubInfo',
  computed: {
    returnParam () {
      var o = {}
      var s
      for (s in this.$data) {
        o[s] = this[s]
      }
      return o
    },
    title () {
      return this.option.param.title
    }
  },
  methods: {
    removeImg () {

    },
    cutString (st) {
      return (st.length > 10) ? st.substring(0, 20) + '...' : st
    },
    submit () {
      if (this.creator === null || this.creator === '') {
        this.alert('저자를 입력해주세요', '107', true)
      } else if (this.date === null || this.date === '') {
        this.alert('발행일을 입력해주세요', '107', true)
      } else if (this.date.length > 8 || this.date.length < 8) {
        this.alert('발행일이 잘못입력되었습니다', '107', true)
      } else if (this.publisher === null || this.publisher === '') {
        this.alert('발행처를 입력해주세요', '107', true)
      } else if (this.phone === null || this.phone === '') {
        this.alert('전화번호를 입력해주세요', '107', true)
      } else if (this.addr === null || this.addr === '') {
        this.alert('주소를 입력해주세요', '107', true)
      } else if (this.email === null || this.email === '') {
        this.alert('이메일을 입력해 주세요', '107', true)
      } else if (this.isbn === null || this.isbn === '') {
        this.alert('ISBN 을 입력해 주세요', '107', true)
      } else {
        this.$emit('submit', this.returnParam)
      }
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
#EpubInfo {
  padding: 10px 0;
  width: 600px;
}
.popup-body {
  display: flex;
  flex-direction: column;
  line-height: 30px;
  padding: 0px;
  margin: 0px;
}
.input > span {
  width: 130px;
  text-align: right;
  padding-right: 10px;
  margin-right: 10px;
  background-color: var(--block-g-bg);
}
.popup-body > li:last-child {
  display: flex;
  list-style: none;
  text-align: left;
  line-height: 20px;
  padding: 15px;
  font-size: 0.9em;
}
.popup-body .input {
  border-bottom: 1px solid var(--line-guide);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/EpubInfo.vue